import { createIcon } from './create-icon'

export const Lock = createIcon({
  displayName: 'Lock',
  paths: [
    'M298.667 341.333c0-117.845 95.531-213.333 213.333-213.333s213.333 95.488 213.333 213.333v42.667h42.667c47.104 0 85.333 38.229 85.333 85.333v341.333c0 47.104-38.229 85.333-85.333 85.333h-512c-47.104 0-85.333-38.229-85.333-85.333v-341.333c0-47.104 38.229-85.333 85.333-85.333h42.667v-42.667zM384 384h256v-42.667c0-70.571-57.429-128-128-128s-128 57.429-128 128v42.667zM256 810.667h512v-341.333h-512v341.333zM512 554.667c-47.104 0-85.333 38.229-85.333 85.333s38.229 85.333 85.333 85.333c47.104 0 85.333-38.229 85.333-85.333s-38.229-85.333-85.333-85.333z'
  ]
})
